export const IOS_DOWNLOAD_URL = 'https://apps.apple.com/app/id6447832559';
export const ANDROID_DOWNLOAD_URL = 'https://play.google.com/store/apps/details?id=xyz.popcoinstudio.gptai';